import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { candidateExamService } from "../../service/CandidateExam/candidateExam.service";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import CandidateInterviewQuestion from "../CandidateInterviewQuestion";
import { ValidateLinkResponse } from "./CandidateExam.model";
import { useContext } from "react";
import { MessageContext } from "../../context/MessageContext";

export default function CandidateExam() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const candidateName = searchParams.get("name");
  const { pushMessageForToast } = useContext(MessageContext);

  const [startExam, setStartExam] = useState(false);
  const [loading, setLoading] = useState(false);

  const [validateLinkResponse, setValidateLinkResponse] =
    useState<ValidateLinkResponse | null>(null);

  const [agreed, setAgreed] = useState(false);

  if (!token) {
    return (
      <Card className="p-card-danger">
        <h2 style={{ color: "red" }}>Invalid Link</h2>
        <p>Token missing</p>
      </Card>
    );
  }

  const handleStartExam = async () => {
    setLoading(true);

    const response = await candidateExamService.validateExamLink(token);

    if (!response.valid) {
      pushMessageForToast({
        severity: "error",
        message: response?.errors?.message || "Invalid or expired exam link",
      });

      setLoading(false);
      return;
    }

    setValidateLinkResponse(response);
    setStartExam(true);
    setLoading(false);
  };

  return (
    <Card>
      {startExam && validateLinkResponse ? (
        <CandidateInterviewQuestion
          interviewQuestions={validateLinkResponse.questions}
          exam_id={validateLinkResponse.exam_id}
        />
      ) : (
        <>
          <h2>Welcome{candidateName ? `, ${candidateName}` : ""}</h2>
          <p>Please read the following exam rules carefully before starting:</p>

          <ul style={{ marginBottom: 16 }}>
            <li>Refreshing or switching tabs will terminate the exam.</li>
            <li>Do not open other tabs or windows.</li>
            <li>Do not use browser navigation buttons.</li>
            <li>Suspicious activity may auto-terminate the exam.</li>
            <li>Exam timer cannot be paused.</li>
            <li>Answers are saved automatically.</li>
            <li>
              Once you click on Submit, the entire exam will be submitted and
              cannot be changed afterward. Please submit only when you are
              completely sure about your answers.
            </li>
            <li>
              The first question is a typing test, and it is mandatory to spend
              at least 1 minute on it.
            </li>
            <li>
              Once the typing test is done then other questions will be unlocked
              and you can click on them to answer, but you cannot go back to the
              typing test again.
            </li>
          </ul>

          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
            <input
              type="checkbox"
              id="agreeRules"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              style={{ marginRight: 8 }}
            />
            <label htmlFor="agreeRules">
              I have read and agree to the exam rules above.
            </label>
          </div>

          <Button
            onClick={handleStartExam}
            disabled={!agreed || loading}
            loading={loading}>
            Start Exam
          </Button>
        </>
      )}
    </Card>
  );
}
